<template lang="pug">
	.dashboard(v-if="campaign")
		.flex-col.space
			.flex-row.justify.wrap.nav-header-wrapper
				.flex-col.nav-header
					.flex-row.space
						a(@click="() => $router.push({ path: `/dashboard/List` })") {{$tCaption('Campaigns')}}
						.spacer /
						span.nowrap {{campaign.Name}}
				.campaign-data.flex-row
					.flex-row.campaign-info
						.flex-col.block {{$tCaption('Buy')}}
						.flex-col.block.align-end.justify.center
							.flex-row.grey.upper.font-small {{formatDate(campaign.StartDate)}} - {{formatDate(campaign.EndDate)}}
							.flex-row {{campaign.AdvertiserName}} {{campaign.BusinessCategory}}
						.flex-col.block.align-end
							.flex-row.grey.upper.font-small {{$tCaption('Impressions')}}
							.flex-row {{formatNumber(campaign.TotalTargetImpressions)}}
						.flex-col.block.align-end
							.flex-row.grey.upper.font-small {{$tCaption('GRPs')}}
							.flex-row {{formatNumber(campaign.TotalTargetGRP)}}
						.flex-col.block.align-end
							.flex-row.grey.upper.font-small {{$tCaption('Budget')}}
							.flex-row ${{formatNumber(campaign.Budget, 'fixedPoint')}}
			.flex-row.area.space.wrap
				template(v-if="campaign")
					.totals.flex-row
						.flex-col.align-end
							span.grey.upper.font-small {{$tCaption('Progress')}}
							span {{formatNumber(this.progress || 0, '###0.#')}}%
						.flex-col.align-end
							span.grey.upper.font-small {{$tCaption('Impressions delivered')}}
							span {{formatNumber(this.impressionsDelivered || 0, 'fixedPoint', 0)}}
						.flex-col.align-end(v-if="campaign.TotalTargetGRP > 0")
							span.grey.upper.font-small {{$tCaption('GRPs delivered')}}
							span {{formatNumber(this.grpsDelivered || 0, 'fixedPoint', 0)}}
						.flex-col.align-end(v-if="campaign.TrafficTotalSpots > 0")
							span.grey.upper.font-small {{$tCaption('Spots delivered')}}
							span {{formatNumber(this.spotsDelivered || 0, 'fixedPoint', 0)}}
				.flex-col.center
					span.upper.font-small.grey {{$tCaption('Period from')}}
					DxDateBox(:value="period.from", @value-changed="v => period.from = v.value", :show-clear-button="true", :width="150")
				.flex-col.center
					span.upper.font-small.grey {{$tCaption('Period to')}}
					DxDateBox(:value="period.to", @value-changed="v => period.to = v.value", :show-clear-button="true", :width="150")
				.flex-col.number-widget.center.align-end(v-if="avg_income != null")
					span.upper.font-small.grey {{$tCaption('Average home value')}}
					span.number-data {{formatNumber(avg_home_value, 'currency')}}
				.flex-col.number-widget.center.align-end(v-if="avg_income != null")
					span.upper.font-small.grey {{$tCaption('Average income')}}
					span.number-data {{formatNumber(avg_income, 'currency')}}
				.flex-col.center.number-widget(v-if="filteredZips && filteredZips.length")
					span.upper.font-small.grey {{$tCaption('Zips')}}
					.flex-row.zips-tag-box
						DxTagBox(
							:items="filteredZips.map(f => f)",
							:value="filteredZips.map(f => f)",
							:show-selection-controls="true",
							:multiline="false",
							:max-displayed-tags="1",
							:width="160",
							select-all-mode="allPages",
							@selection-changed="filteredZipTagBoxChanged")
			.flex-row(v-if="quoteNumber")
				.flex-col.justify
					.loading.flex-row.space(v-if="isLoading")
						.loader
							i.fas.fa-circle-notch.fa-spin
						span {{$tCaption('Loading')}}..
					.dashboard-items(v-else)
						.impressions-map-holder
							ImpressionsMap(:items="filteredCampaignData", :quoteNumber="quoteNumber", @select-zips="onFilterZips")
							DxDataGrid.products-total-grid.compact(:width="430", :data-source="productsTotalStore", :show-borders="true", @selection-changed="v => filteredProducts = v.selectedRowKeys", :selectedRowKeys="filteredProducts")
								DxSelection(:deferred="false", mode="multiple")
								DxColumn(data-field="name", :caption="$tCaption('Name')", :width="120")
								DxColumn(data-field="clicks", :caption="$tCaption('Clicks')", format="fixedPoint", :width="90")
								DxColumn(data-field="impressions", :caption="$tCaption('Impressions')", format="fixedPoint", :width="90")
								DxColumn(data-field="ctr", :caption="$tCaption('CTR')", :format="{ type: 'percent', precision: 2 }", :width="80")
								DxSummary(:calculate-custom-summary="calculateCustomSummary")
									DxTotalItem(column="clicks", summary-type="sum",  display-format="{0}", value-format="fixedPoint")
									DxTotalItem(column="impressions", summary-type="sum",  display-format="{0}", value-format="fixedPoint")
									DxTotalItem(name="ctr", summary-type="custom",  display-format="{0}", :value-format="{ type: 'percent', precision: 2 }", show-in-column="ctr")
						.products-data
							DxTabs(:data-source="filteredProductsObjects", :selected-item="filteredProductsObjects[currentTabProductIndex]", @item-click="v => currentTabProductIndex = v.itemIndex")
							ProductData(:campaign="campaign", :items="filteredCampaignData.filter(f => f.product === filteredProductsObjects[currentTabProductIndex].id)", :product="filteredProductsObjects[currentTabProductIndex]")
</template>

<script>
	import _ from 'lodash';
	import api from 'view/carto/api';
	import axios from 'axios';
	import DxSelectBox from 'devextreme-vue/select-box';
	import moment from 'moment';
	import Data from 'app-core/Data';
	import {
		DxDataGrid,
		DxColumn,
		DxSelection,
		DxSummary,
		DxTotalItem
	} from 'devextreme-vue/data-grid';
	import ImpressionsMap from './ImpressionsMap.vue';
	import DxDateBox from 'devextreme-vue/date-box';
	import DxButton from 'devextreme-vue/button';
	import DxTagBox  from 'devextreme-vue/tag-box';
	import DxTabs from 'devextreme-vue/tabs';
	import ProductData from './ProductData.vue';

	export default {
		translationCategory: 'dashboard.Dashboard',
		name: 'dashboard',
		components: {
			DxSelectBox,
			DxDataGrid,
			DxColumn,
			DxSelection,
			DxSummary,
			DxTotalItem,
			ImpressionsMap,
			DxDateBox,
			DxButton,
			DxTabs,
			ProductData,
			DxTagBox
		},
		data() {
			return {
				campaign: null,
				campaignData: [],
				products: [],
				productsTotal: [],
				filteredProducts: [],
				zips: [],
				period: {
					from: null,
					to: null
				},
				isLoading: false,
				filteredZips: [],
				currentTabProductIndex: 0,
				avg_home_value: null,
				avg_income: null
			};
		},
		computed: {
			productsTotalStore() {
				return {
					store: {
						type: 'array',
						key: 'id',
						data: this.productsTotal
					}
				};
			},
			filteredCampaignData() {
				return this.campaignData.filter(f =>
					this.filteredProducts.indexOf(f.product) > -1
					&& (!this.period.from || f.date >= this.period.from) && (!this.period.to || f.date <= this.period.to)
					&& (this.filteredZips === null || !this.filteredZips.length || this.filteredZips.indexOf(f.zip) > -1));
			},
			productNames() {
				return this.productsObjects.map(f => f.name);
			},
			productsObjects() {
				return this.availableProducts.map(id => _.find(this.products, {id}));
			},
			filteredProductsObjects() {
				return _.sortBy(this.productsTotal.filter(f => f.impressions).map(f => _.find(this.products, {name: f.name})).map(f => ({...f, text: f.name })), ['name']);
			},
			quoteNumber() {
				return this.$router && this.$router.currentRoute && this.$router.currentRoute.params.quoteNumber;
			},
			availableProducts() {
				return _.uniqBy(this.campaignData, 'product').map(f => f.product);
			},
			impressionsDelivered() {
				return this.campaign && this.campaign.TotalDeliveredImpressions || 0;
			},
			grpsDelivered() {
				return this.campaign && this.campaign.TotalDeliveredGRPs || 0;
			},
			spotsDelivered() {
				return this.campaign && this.campaign.TrafficSpotsAired || 0;
			},
			progress() {
				return (this.spotsDelivered ? (this.spotsDelivered * 100 / this.campaign.TrafficTotalSpots) : (this.impressionsDelivered * 100 / this.TotalTargetImpressions)) || 0;
			}
		},
		watch: {
			filteredCampaignData() {
				this.loadProductsTotal();
			},
			filteredProductsObjects() {
				if (this.currentTabProductIndex < 0) {
					this.currentTabProductIndex = 0;
				} else if (this.filteredProductsObjects.length && this.currentTabProductIndex >= this.filteredProductsObjects.length) {
					this.currentTabProductIndex = this.filteredProductsObjects.length - 1;
				}
			},
			filteredZips() {
				this.calculateZipTotals();
			}
		},
		mounted() {
			Data.loadProducts().then(r => {
				this.products = r;
				return Data.getDeliveredCampaignData(this.quoteNumber).then(r => {
					this.campaignData = r;
					this.filteredProducts = [...this.productsObjects.map(f => f.id)];
				});
			});
			Data.getCampaign(this.quoteNumber).then(r => {
				if (__DEBUG__)
					console.log('Campaign data loded', { r });
				this.campaign = r;
			});
		},
		methods: {
			formatDate(d) {
				return d ? moment(d).format('L') : null;
			},
			formatNumber(a, b, c) {
				if (!b) {
					if (a > 1000) b = this.$tCaption('thousands');
					if (a > 1000000) b = this.$tCaption('millions');
				}
				return Data.formatNumber(a, b || 'fixedPoint', c !== null ? c : 1);
			},
			filteredZipTagBoxChanged(e) {
				if (__DEBUG__)
					console.info('Removed zip manually', e);
				if (e.removedItems) {
					e.removedItems.map(zip => {
						var idx = this.filteredZips.indexOf(zip);
						if (idx > -1)
							this.filteredZips.splice(idx, 1);
					});
				}
			},
			onFilterZips(zips) {
				this.filteredZips = `${this.filteredZips}` === `${zips}` ? null : zips;
			},
			calculateCustomSummary(options) {
				if (options.name === 'ctr') {
					if (options.summaryProcess === 'start') {
						options.totalValue = {
							clicks: 0,
							impressions: 0
						};
					} else if (options.summaryProcess === 'calculate') {
						if (options.component.isRowSelected(options.value.name)) {
							options.totalValue.impressions += options.value.impressions || 0;
							options.totalValue.clicks += options.value.clicks || 0;
						}
					} else if (options.summaryProcess === 'finalize') {
						options.totalValue = options.totalValue.clicks / options.totalValue.impressions;
					}
				}
			},
			loadProductsTotal() {
				var data = [];
				var groups = _.groupBy(this.filteredCampaignData, 'product');
				if (__DEBUG__)
					console.info('Load products total', { groups });
				this.productsObjects.map(prod => {
					var group = {
						id: prod.id,
						name: prod.name,
						impressions: _.sumBy(groups[prod.id], f => f.impressions),
						clicks: _.sumBy(groups[prod.id], f => f.clicks),
					};
					group.ctr = Number(parseFloat(group.clicks / group.impressions).toFixed(4)) || 0;
					data.push(group);
				});
				this.productsTotal = data;
			},
			calculateZipTotals() {
				if (!this.filteredZips || !this.filteredZips.length) {
					this.avg_income = null;
					this.avg_home_value = null;
					return;
				}
				const query = `select avg(a_med_in_1) as avg_income, avg(a_med_valu) as avg_home_value from (SELECT a_med_in_1, ${api.stringToDecimalField('a_med_valu')}, zcta5ce10 FROM alluszipswithdata) data where zcta5ce10 in (${this.filteredZips.map(f => `'${f}'`).join(',')})`;
				return axios.get(`https://${api.username}.carto.com/api/v2/sql?q=${encodeURIComponent(query)}&api_key=${api.apiKey}`).then((response) => {
					if (__DEBUG__)
						console.log('Zips totals loaded', response);
					this.avg_income = response.data.rows[0].avg_income;
					this.avg_home_value = response.data.rows[0].avg_home_value;
				});
			}
		}
	};
</script>
<style lang='scss'>
	.dashboard {
		@import "main/themes/generated/variables.base.scss";

		padding: 10px;

		.campaign-data {
			justify-content: center;

			.campaign-info {
				border-radius: 4px;
				background: rgba(0, 0, 0, 0.02);
				min-width: 20vw;
				justify-content: space-around;

				> .block {
					padding: 10px;
					justify-content: center;
					color: $base-accent;

					&:not(:last-child) {
						border-right: 1px solid rgba(0,0,0,0.03);
					}
				}
			}
		}

		.totals {
			align-items: center;
			font-size: 24px;
			font-weight: 100;

			> * {
				padding: 10px;
			}
		}

		.text-overflow {
			overflow: hidden;
			text-overflow: ellipsis;
			width: 140px;
			white-space: nowrap;
			line-height: 32px;
		}

		.hidden {
			visibility: collapse;
		}

		.header-label {
			font-size: 12px;
			color: #c1c1c1;
			text-transform: uppercase;
		}

		.area {
			padding: 10px;
			background: #fff;
		}

		.compact {
			tr.dx-row > td:not(.no-padding) {
				padding: 8px !important;
			}

			tr.dx-row > td.no-padding {
				padding: 0px !important;
			}

			&.dx-button {
				margin-top: -4px;
			}
		}

		.impressions-map-holder {
			position: relative;
		}

		.products-total-grid {
			position: absolute;
			top: 10px;
			left: 50px;
			z-index: 1000;
			opacity: 0.9;
		}

		.dx-item.dx-tab.dx-tab-selected {
			background: #e6e6e6 !important;
		}

		.dx-tagbox-single-line .dx-tag-container.dx-texteditor-input-container {
			overflow: initial !important;
		}

		.dx-datebox {
			height: 36px;
		}

		.number-data {
			padding: 6px 0px 0px 0px;
			font-size: 24px;
			font-weight: 100;
		}

		.number-widget {
			margin-left: 20px !important;
		}

		.zips-tag-box {
			margin-top: 10px;
		}
	}
</style>
